import { DocumentApi } from "../Repository/eventbookyapi";
import { GetApiConfiguration } from "./ServiceConfiguration";

export abstract class DocumentService {
    public static GetList = async () => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentGet();
    };

    public static Upload = async (file: Blob, overwrite: boolean) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentPost({ file, overwrite });
    };

    public static Delete = async (id: number) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentIdDelete({ id });
    };

    public static Download = async (id: number) => {
        return new DocumentApi(GetApiConfiguration()).apiDocumentDownloadIdGetRaw({ id });
    };
}
